/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.ts" />
(
    function (skyward, $) {
        skyward.applicationclaim = skyward.applicationclaim || {};

        var defaultSettings =
        {
            title: "Insert Field",
            onFieldSelect: function () { },
            onCancel: function () { }
        };

        skyward.applicationclaim.popSetClaimSourceField = function (button)
        {
            let buttonData = $(button).data();
            var mode = buttonData.mode;
            var screen = buttonData.screen;
            var container = $(button).parents(".claimSourceFieldWrapper");
            var dataModule = "Security";
            var dataObject = "User";
            var clickedElement = $(this);

            var options =
            {
                mode: mode,
                screen: screen,
                anchorTo: clickedElement,
                beforeClose: preCloseInsertColumnMenu,
                onFieldSelect: function (field) { setSourceField(container, field); }
            };

            skyward.applicationclaim.openSelectFieldDialog(dataModule, dataObject, options);
        };

        var preCloseInsertColumnMenu = function ()
        {
            insertColumnDiv = [];
            treeGridDiv = [];
        };

        var setSourceField = function (container, fieldData)
        {
            // fieldData /should/ be a treebrowse=>FormattedFieldProps TypeScript Type.
            var backingFieldToUpdate = container.find(".acSource");
            skyward.controls.setValue(backingFieldToUpdate, fieldData.guidAbsoluteFieldPath, false);
            var displayFieldToUpdate = container.find(".acSourceDisplayValue");
            skyward.controls.setValue(displayFieldToUpdate, fieldData.absoluteFieldPath, false);
        };

        skyward.applicationclaim.openSelectFieldDialog = function (module, object, options)
        {
            var settings = $.extend({}, defaultSettings, options);
            var selectFieldDialog;

            var onSaveClick = function () {
                var fieldData = skyward.treebrowse.getSelectedFieldData(selectFieldDialog.content);
                selectFieldDialog.close();
                settings.onFieldSelect(fieldData);
            };
            var onCancelClick = function () {
                selectFieldDialog.close();
                settings.onCancel();
            };

            var saveButton = { text: "Save", "click": onSaveClick, "icon": "Save" };
            var cancelButton = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };
            selectFieldDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButton, cancelButton], settings);
            selectFieldDialog.content.on("treeBrowseSave", onSaveClick);
        };

        var buildTreePopup = function (module, object, options)
        {
            var mode = options.mode;
            var screen = options.screen

            if (!mode) {
                return;
            }

            var url = skyward.global.virtualDir + screen + mode + '/';
            return $.ajax({
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    module: module,
                    object: object
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);